module.exports = __webpack_public_path__ + "img/no-msg.4fa2a710.png";